// actions.js
import {FETCH_USER_ROLE,FETCH_USER_ROLE_ERROR,FETCH_USER_ROLE_SUCCESS,LOGIN,LOGIN_SUCCESS,LOGIN_ERROR,LOGIN_WITH_OTP,LOGIN_WITH_OTP_SUCCESS,LOGIN_WITH_OTP_ERROR, RESET_PASSWORD, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR, FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_ERROR, GET_PROFILE, GET_PROFILE_SUCCESS, GET_PROFILE_ERROR} from '../actionTypes'

export const fetchUserRole = (navigate) => ({
  type: FETCH_USER_ROLE,
  payload: {navigate}
});

export const fetchUserRoleSuccess = (data) => ({
  type: FETCH_USER_ROLE_SUCCESS,
  payload: data,
});

export const fetchUserRoleError = (error) => ({
  type: FETCH_USER_ROLE_ERROR,
  payload: error,
});
export const login = (userDetails, navigate, remember, toast, setLoading, showToast, setShowToast, setCaptcha) => ({
  type: LOGIN,
  payload: { userDetails, navigate, remember, toast, setLoading, showToast, setShowToast, setCaptcha },
});

export const loginSuccess = (data) => ({
  type: LOGIN_SUCCESS,
  payload: data,
});

export const loginError = (error) => ({
  type: LOGIN_ERROR,
  payload: error,
});
export const loginWithOtp = (userOtpDetails,location, navigate,toast, setLoading,dispatch) => ({
  type: LOGIN_WITH_OTP,
  payload: { userOtpDetails,location, navigate,toast, setLoading,dispatch },
});

export const loginWithOtpSuccess = (data) => ({
  type: LOGIN_WITH_OTP_SUCCESS,
  payload: data,
});

export const loginWithOtpError = (error) => ({
  type: LOGIN_WITH_OTP_ERROR,
  payload: error,
});

export const forgotPassword = (email, navigate,toast) => ({
  type: FORGOT_PASSWORD,
  payload: { email, navigate,toast },
});

export const forgotPasswordSuccess = (data) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: data,
});

export const forgotPasswordError = (error) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: error,
});

export const resetPassword = (newPassword, token, navigate, toast) => ({
  type: RESET_PASSWORD,
  payload: { newPassword, token, navigate, toast },
});

export const resetPasswordSuccess = (data) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: data,
});

export const resetPasswordError = (error) => ({
  type: RESET_PASSWORD_ERROR,
  payload: error,
});

export const getUserProfileDetails = () => ({
  type: GET_PROFILE,
});

export const getUserProfileDetailsSuccess = (data) => ({
  type: GET_PROFILE_SUCCESS,
  payload: data,
});

export const getUserProfileDetailsError = (error) => ({
  type: GET_PROFILE_ERROR,
  payload: error,
});
